import { MessagePrimitive } from '@assistant-ui/react';
import { Accordion } from '@mantine/core';

import classes from './CollapsibleToolRun.module.css';
import { ToolDisplay } from '#plugin-chat/components/tool-display/ToolDisplay.tsx';

interface CollapsibleToolRunProps {
  indices: readonly number[];
}

/**
 * Renders a run of consecutive collapsible tool-call parts.
 *
 * Layout:
 * - Summary toggle: "Show N tools" / "Hide N tools" (pill button).
 * - Collapse panel: each tool's normal render via `MessagePrimitive.PartByIndex`
 *   (falling back to `ToolDisplay` — same as today's rendering).
 * - Progress bubble: rendered below the toggle whenever the run's last part is
 *   still running (result === undefined). Shown in both collapsed and expanded
 *   states to keep the "AiPSO Agent is ..." indicator visible while work
 *   continues.
 */
export function CollapsibleToolRun({ indices }: CollapsibleToolRunProps) {
  const toolCount = indices.length;
  return (
    <div className={classes.toolRun}>
      <Accordion chevronPosition="left" classNames={{ label: classes.accordionLabel }} variant="unstyled">
        <Accordion.Item bg="transparent" value="tool-run">
          <Accordion.Control c="dark.2" className={classes.toolRunToggle} fz="sm">
            Used {toolCount} tool{toolCount === 1 ? '' : 's'}
          </Accordion.Control>
          <Accordion.Panel>
            <div className={classes.content}>
              {indices.map((index) => (
                <MessagePrimitive.PartByIndex components={components} index={index} key={index} />
              ))}
            </div>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

const components = { tools: { Fallback: ToolDisplay } };
